import { useState } from "react";
import TickIcon    from "./TickIcon";
import ReplyPreview from "./ReplyPreview";
 
export default function MessageBubble({ msg }) {
  const [expanded, setExpanded] = useState(false);
  const isMe = msg.fromMe;
 
  // ── Image bubble ──
  if (msg.type === "image") {
    return (
      <div style={{ display: "flex", justifyContent: "flex-start", marginBottom: 6 }}>
        <div style={{ ...styles.bubble, background: "#f1f5f9", padding: 4, maxWidth: 200 }}>
          <div style={styles.imagePlaceholder}>
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none"
              stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="2" />
              <circle cx="8.5" cy="8.5" r="1.5" />
              <polyline points="21 15 16 10 5 21" />
            </svg>
          </div>
          <span style={{ fontSize: 11, color: "#94a3b8", padding: "2px 6px 4px", display: "block", textAlign: "right" }}>
            {msg.time}
          </span>
        </div>
      </div>
    );
  }
 
  // ── Text bubble ──
  const displayText =
    msg.truncated && !expanded
      ? msg.text.slice(0, 300)
      : msg.text;

  const textColor = isMe ? "#000000" : "#ffffff";

  return (
    <div
      style={{
        display: "flex",
        justifyContent: isMe ? "flex-end" : "flex-start",
        marginBottom: 4,
      }}
    >
      <div
        style={{
          ...styles.bubble,
          background:   isMe ? "#f3dab5ff" : "#244939",
          borderRadius: isMe
            ? "14px 14px 4px 14px"
            : "14px 14px 14px 4px",
          border: isMe
            ? "1px solid #f3dab5ff"
            : "1px solid #244939",
        }}
      >
        {/* Group sender name */}
        {msg.senderName && (
          <span style={styles.senderName}>{msg.senderName}</span>
        )}
 
        {/* Reply quote */}
        {msg.replyTo && <ReplyPreview replyTo={msg.replyTo} />}
 
        {/* Message text */}
        <p style={{ ...styles.text, color: textColor }}>
          {displayText}
          {msg.truncated && !expanded && (
            <>
              {"... "}
              <button onClick={() => setExpanded(true)} style={styles.readMore}>
                Read more
              </button>
            </>
          )}
        </p>
 
        {/* Time + tick row */}
        <div style={styles.meta}>
          <span style={styles.time}>{msg.time}</span>
          {isMe && <TickIcon status={msg.status} />}
        </div>
      </div>
    </div>
  );
}
 
const styles = {
  bubble: {
    maxWidth: "65%",
    minWidth: 80,
    padding: "8px 12px 6px",
    boxShadow: "0 1px 2px rgba(0,0,0,0.06)",
  },
  imagePlaceholder: {
    width: 190,
    height: 110,
    background: "#e2e8f0",
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  senderName: {
    display: "block",
    fontSize: 12,
    fontWeight: 600,
    color: "#1a3c5e",
    marginBottom: 3,
  },
  text: {
    margin: 0,
    fontSize: 14,
    lineHeight: 1.55,
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
  },
  readMore: {
    background: "none",
    border: "none",
    padding: 0,
    cursor: "pointer",
    color: "#9afa89ff",
    fontWeight: 600,
    fontSize: 13,
  },
  meta: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: 4,
    marginTop: 4,
  },
  time: {
    fontSize: 11,
    color: "#94a3b8",
  },
};